<div>
    @if(isDesktop){
    <div class="d-flex profile-media">
        <div class="flex-grow-1">
            <span>{{firstName}} {{lastName}} <i class="middle fa-solid fa-angle-down"></i></span>

            <p class="mb-0">
                <!--  {{roleName}} -->

            </p>
        </div>
    </div>
    }
    @else {
    <app-feather-icons [icon]="'user'"></app-feather-icons>
    }

</div>

<ul class="profile-dropdown onhover-show-div">
    <a routerLink="/settings" class="dropdown-item pl-3 py-3" tourAnchor="start-postavke">
        <i class="fa fa-cog fa-lg fa-fw me-2"></i>
        Postavke
    </a>

    <a class="dropdown-item pl-3 py-3" (click)="openClipboard()">
        <i class="fa fa-clipboard fa-lg fa-fw me-2"></i>
        {{"PROPERTIES.Međuspremnik" | translate}}
    </a>

    @if (isAuthorized('neolab.solazur-sync')) {
    <a class="dropdown-item pl-3 py-3" (click)="openNeolabSync()">
        <i class="fa fa-sync fa-lg fa-fw me-2"></i>
        Neolab sync
    </a>
    }

    <button (click)="downloadTringExtension()" class="dropdown-item pl-3 py-3">
        <i class="fa fa-download fa-lg fa-fw me-2"></i>
        TRING ekstenzija
    </button>

    <button (click)="downloadNSCExtension()" class="dropdown-item pl-3 py-3">
        <i class="fa fa-cloud-download fa-lg fa-fw me-2"></i>
        NSC ekstenzija
    </button>

    <button (click)="logout()" class="dropdown-item pl-3 py-3">
        <i class="fa fa-sign-out fa-lg fa-fw me-2"></i>
        Odjavi se
    </button>
</ul>